import { Routes } from '@angular/router';
import { HomeLayoutComponent } from './components/layouts/home-layout/home-layout.components';
import { CustomerSearchComponent } from './components/customer-search/customer-search.component';
import { UserPermission } from './models/permission.model';
import { permissionGuard } from './guards/permission.guard';
import { CustomerVouchersComponent } from './components/customer-vouchers/customer-vouchers.component';
import { VoucherReportsComponent } from './components/voucher-reports/voucher-reports.component';
import { VoucherRevokeComponent } from './components/voucher-revoke/voucher-revoke.component';
import { VoucherInsightsComponent } from './components/voucher-insights/voucher-insights.component';
import { PartnerInvoicesComponent } from './components/partner-invoices/partner-invoices.component';
import { PendingRedemptionsComponent } from './components/pending-redemptions/pending-redemptions.component';


export const routes: Routes = [
  {
    path: '',
    component: HomeLayoutComponent,
    children: [
      { path: '', component: CustomerSearchComponent },
      { path: 'customer/:customerId/vouchers', component: CustomerVouchersComponent },
      { path: 'reports', component: VoucherReportsComponent },
      { path: 'insights', component: VoucherInsightsComponent },
      { path: 'revoke', component: VoucherRevokeComponent },
      { 
        path: 'invoices', 
        component: PartnerInvoicesComponent,
        canActivate: [permissionGuard(UserPermission.Partner_ViewInvoices)]
      },
      {
        path: 'pending-redemptions',
        component: PendingRedemptionsComponent
      },

    ],
  },
  // Wildcard route for handling unknown routes
  { path: '**', redirectTo: '' }
];

